import React from 'react';

import { Button } from '@appcharge/shared-ui';

import { FilterPopover } from 'components/FilterComponents/FilterPopover/FilterPopover';
import {
  FilterOption,
  FilterType
} from 'components/FilterComponents/FilterPopover/types';

const STATUS_OPTIONS: FilterOption[] = [
  { label: 'Active', value: 'active' },
  { label: 'Inactive', value: 'inactive' }
];

interface IRewardCalendarFiltersProps {
  externalIdFilter: string;
  onExternalIdChange: (value: string) => void;
  nameFilter: string;
  onNameChange: (value: string) => void;
  statusFilter: string[];
  onStatusChange: (value: string) => void;
  offerDesignFilter: string[];
  offerDesignOptions: FilterOption[];
  onOfferDesignChange: (value: string) => void;
  createdAtFilter: string;
  onCreatedAtChange: (value: string) => void;
  hasAnyFilter: boolean;
  onClearFilters: () => void;
}

export const RewardCalendarFilters = ({
  externalIdFilter,
  onExternalIdChange,
  nameFilter,
  onNameChange,
  statusFilter,
  onStatusChange,
  offerDesignFilter,
  offerDesignOptions,
  onOfferDesignChange,
  createdAtFilter,
  onCreatedAtChange,
  hasAnyFilter,
  onClearFilters
}: IRewardCalendarFiltersProps): React.ReactElement => {
  const filterConfigs = [
    {
      key: 'externalId',
      label: 'External ID',
      filterType: FilterType.FREE_SEARCH,
      onChange: onExternalIdChange,
      getSelectedItems: () => (externalIdFilter ? [externalIdFilter] : [])
    },
    {
      key: 'name',
      label: 'Name',
      filterType: FilterType.FREE_SEARCH,
      onChange: onNameChange,
      getSelectedItems: () => (nameFilter ? [nameFilter] : [])
    },
    {
      key: 'status',
      label: 'Status',
      filterType: FilterType.AUTOCOMPLETE_CHECKLIST as FilterType,
      options: STATUS_OPTIONS,
      onChange: onStatusChange,
      getSelectedItems: () => statusFilter
    },
    {
      key: 'offerDesign',
      label: 'Offer Design',
      filterType: FilterType.AUTOCOMPLETE_CHECKLIST as FilterType,
      options: offerDesignOptions,
      onChange: onOfferDesignChange,
      getSelectedItems: () => offerDesignFilter
    },
    {
      key: 'createdAt',
      label: 'Created At',
      filterType: FilterType.DATE_PICKER,
      onChange: onCreatedAtChange,
      getSelectedItems: () => (createdAtFilter ? [createdAtFilter] : [])
    }
  ];

  return (
    <div className="flex items-center gap-1 flex-wrap px-7 mb-5">
      {filterConfigs.map(({ key, getSelectedItems, ...filterProps }) => (
        <FilterPopover
          key={key}
          selectedItems={getSelectedItems()}
          {...filterProps}
        />
      ))}
      {hasAnyFilter && (
        <Button
          variant="link"
          onClick={onClearFilters}
          className="text-indigo-600 hover:text-base-primary text-xs border-none shadow-none"
        >
          Clear filters
        </Button>
      )}
    </div>
  );
};
